import { Component, EventEmitter, Output } from '@angular/core';
import { Note } from 'src/app/people/models/note';
import { PersonScenarioRequirement } from '../../models/credential/personScenarioRequirement';
import { PersonProfileService } from 'src/app/people/profile/person-profile.service';
import { ModalConfirmationComponent } from '../modal-confirmation/modal-confirmation.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
  selector: 'scenario-notes-sidebar',
  templateUrl: './scenario-notes-sidebar.component.html',
  styleUrls: ['./scenario-notes-sidebar.component.scss'],
})
export class ScenarioNotesSidebarComponent {
  @Output() close = new EventEmitter();
  @Output() open = new EventEmitter();
  public requirement: PersonScenarioRequirement;
  public notes: Note[] = [];
  public loaded = false;
  public personId: string;
  constructor(private profileService: PersonProfileService, private dialog: MatDialog) {}

  ngOnInit(): void {}

  openNotes(requirement: PersonScenarioRequirement, notes: Note[]) {
    if (notes.length) this.personId = notes[0].personId;
    this.requirement = requirement;
    this.notes = notes;
    this.open.emit();
    this.loaded = true;
    event.stopPropagation();
  }

  onClose() {
    this.requirement = null;
    this.notes = [];
    this.close.emit();
    this.loaded = false;
  }

  deleteNote(note: Note) {
    this.openDeleteDialog(`Delete this note`, () => {
      this.profileService.deletePersonNote(note.personId, note.id).subscribe(() => {
        this.profileService.getPersonNotes(note.personId);
        this.profileService.openSnackBar(`Successfully deleted note`, true);
      });
    });
  }

  openDeleteDialog(action: string, successCallback: any) {
    this.dialog
      .open(ModalConfirmationComponent, {
        data: { action: action, delete: true },
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          successCallback();
        }
      });
  }

  public canDelete(note: Note): boolean {
    return this.profileService.canDeleteNote(note);
  }
}
